import styles from "./CartDetails.module.css";
import Backdrop from "../../Catalogs/Dialog/Backdrop";
import { useState } from "react";
import { useImageUpload } from "../../ClientLogos/hooks/useImageUpload";
import axios from "axios";
import { API } from "../../../config";
import { toast } from "react-toastify";
import { FiDownload } from "react-icons/fi";

export const OrderImagesDialog = ({
  show,
  onClose,
  cartId,
  orderImages = [],
  onImagesUpdated = () => {},
  cartStatus,
}) => {
  const { uploadImage } = useImageUpload();
  const [isUploading, setIsUploading] = useState(false);

  if (!show) return null;

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsUploading(true);
      const uploadedUrl = await uploadImage(file);
      const updatedImages = [...orderImages, uploadedUrl];

      await axios.put(`${API}/Admin/carts/${cartId}`, {
        orderImages: updatedImages,
      });

      toast.success("Order image added");
      onImagesUpdated();
    } catch (error) {
      console.error(error);
      toast.error("Failed to add order image");
    } finally {
      setIsUploading(false);
      e.target.value = "";
    }
  };

  const handleDownloadImage = async (url) => {
    try {
      if (!url) return;

      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      const contentType = blob.type || "";
      const rawName = url.split("/").pop() || "image";

      let extension = "";
      if (contentType.includes("png")) extension = ".png";
      else if (contentType.includes("jpeg") || contentType.includes("jpg"))
        extension = ".jpg";
      else if (contentType.includes("webp")) extension = ".webp";

      const hasExtension = /\.[a-zA-Z0-9]+$/.test(rawName);
      const fileName = hasExtension ? rawName : `${rawName}${extension || ".png"}`;

      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Failed to download image", error);
    }
  };

  const canUpload = true;

  return (
    <>
      <Backdrop show={show} switch={onClose} />
      <div className={styles.orderImagesDialog}>
        <div className={styles.orderImagesHeader}>
          <h3 className={styles.orderImagesTitle}>Order Images</h3>
          <button
            type="button"
            className={styles.orderImagesCloseButton}
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className={styles.orderImagesContent}>
          {orderImages && orderImages.length > 0 ? (
            <div className={styles.orderImagesList}>
              {orderImages.map((image, idx) => (
                <div
                  key={idx}
                  className={styles.orderImagesItemWrapper}
                >
                  <img
                    src={image}
                    alt="Order"
                    className={styles.orderImagesItem}
                  />
                  <div
                    className={styles.orderImagesItemDownload}
                    onClick={() => handleDownloadImage(image)}
                    aria-label="Download image"
                  >
                    <FiDownload />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.orderImagesEmpty}>No order images yet.</div>
          )}
        </div>

        {canUpload && (
          <div className={styles.orderImagesFooter}>
            <label className={styles.orderImagesUploadButton}>
              {isUploading ? "Uploading image..." : "Add Order Image"}
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                disabled={isUploading}
                onChange={handleFileUpload}
              />
            </label>
          </div>
        )}
      </div>
    </>
  );
};

